import { Age } from 'frontend/enums'
import { FilterProp, PanelOption } from 'frontend/types'
import { filterTypicalAgeRangeClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { activeOptionLabel } from 'frontend/utils/helpers'
import React from 'react'
import Panel from './Panel/Panel'
import { SearchParams } from 'backend/services/types/urApiService.types'

type EducationLevelProps = {
  educationLevels: FilterProp[]
  handlePanelClick: () => void
  isOpen: boolean
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const EducationLevel = ({
  educationLevels,
  handlePanelClick,
  isOpen,
  searchParams,
  updateSearch,
}: EducationLevelProps) => {
  const { typical_age_range: typicalAgeRange } = searchParams

  const educationLevelOptions = educationLevels.map(educationLevel => {
    return {
      available: educationLevel.available,
      label: educationLevel.label,
      value: educationLevel.value,
    }
  })

  const activeLabels = activeOptionLabel(
    [...educationLevelOptions],
    typicalAgeRange || '',
    true,
  )

  const handleOptionSelect = (option: PanelOption) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterTypicalAgeRangeClick(option.label)

    updateSearch({
      typical_age_range: option.value as Age,
    })
  }

  return (
    <Panel
      activeLabels={activeLabels}
      ariaLabel="Filtrera på utbildningsnivå"
      dataTrk="filter-education-level"
      handlePanelClick={handlePanelClick}
      isOpen={isOpen}
      label="Utbildningsnivå"
      onOptionSelect={handleOptionSelect}
      options={educationLevelOptions}
    />
  )
}

export default EducationLevel
